<template>
  <div
    class="modal fade company-send contact-modal show"
    tabindex="-1"
    style="padding-right: 17px; display: block"
  >
    <div class="modal-dialog modal-lg">
      <div class="modal-content company-communicate-content">
        <div id="contact_form">
          <div class="modal-body">
            <div class="enter-your-password">
              <div class="col-12 d-flex justify-content-between align-items-center">
                <h5 class="m-0">
                  {{ $store.getters.getWordLocale('txt_sifre_giriniz') }}
                </h5>
                <strong class="close-modal" @click="closeLoginModal()">X</strong>
              </div>
              <div class="col-12 verify-e-mail-alert-area">
                <div class="alert alert-info mt-3 mb-3" role="alert">
                  <i class="material-icons-outlined" translate="no">mark_email_unread</i>
                  <p
                    v-if="resultMessage == 'OpenPasswordModal'"
                    class="enter-activation-sent-to-email"
                  >
                    {{ $store.getters.getWordLocale('txt_sifreniz_eposta_adresinize_gonderildi') }}
                  </p>
                  <p v-else class="enter-activation-sent-to-email">
                    {{ $store.getters.getWordLocale('txt_mail_sisteme_kayitli') }}
                  </p>
                </div>
              </div>
              <div class="col-12">
                <form id="verify-user-password">
                  <div class="form-group">
                    <label for="verify-e-mail">{{
                      $store.getters.getWordLocale('txt_eposta')
                    }}</label>
                    <input
                      id="password-e-mail"
                      type="email"
                      class="form-control"
                      disabled=""
                      :value="userEmail"
                      :placeholder="
                        $store.getters.getWordLocale('txt_gecerli_eposta_adresi_giriniz')
                      "
                    />
                  </div>
                  <div class="form-group">
                    <div class="input-group mb-3">
                      <label class="d-block w-100" for="user-password"
                        >{{ $store.getters.getWordLocale('txt_sifre') }}
                        <span class="text text-danger">*</span></label
                      >
                      <input
                        id="user-password"
                        v-model="passwordValue"
                        required=""
                        type="password"
                        class="form-control"
                        placeholder="• • • • • •"
                        style="width: auto"
                      />
                    </div>
                    <div v-show="!isPasswordEntered" class="alert alert-danger mt-2">
                      {{ $store.getters.getWordLocale('txt_sifre_giriniz') }}
                    </div>
                  </div>

                  <button
                    id="send_message_registered_user"
                    type="button"
                    data-color="blue"
                    class="verify-user-password btn btn-secondary w-100 mb-3"
                    :disabled="passwordValue.length < 3"
                    @click="sendMessage()"
                  >
                    <i class="fas fa-check"></i>
                    {{ $store.getters.getWordLocale('txt_gonder') }}
                    <abbr v-show="sendingMessage" class="text-light"
                      ><i class="fa fa-spinner fa-spin"></i
                    ></abbr>
                  </button>
                  <button
                    id="cancel_button"
                    type="button"
                    data-dismiss="modal"
                    class="btn w-100"
                    @click="closeLoginModal()"
                  >
                    {{ $store.getters.getWordLocale('txt_iptal') }}
                  </button>
                  <div
                    v-show="passwordIsWrong"
                    class="alert alert-danger mt-2 password-not-correct"
                  >
                    <span> {{ $store.getters.getWordLocale('txt_sifre_yanlis') }}</span>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    passwordIsWrong: {
      type: Boolean,
      require: true
    },
    sendingMessage: {
      type: Boolean,
      require: true
    },
    userEmail: {
      type: String,
      require: true
    },
    resultMessage: {
      type: String,
      require: true
    }
  },
  data() {
    return {
      inputValue: '',
      passwordValue: '',
      isPasswordEntered: true
    }
  },
  methods: {
    sendMessage() {
      this.$parent.sendMessage(this.passwordValue, '')
    },
    closeLoginModal() {
      this.$parent.closeLoginModal()
    },
    showErrorMessage() {
      if (this.passwordValue == 0) {
        this.isPasswordEntered = false
      } else {
        this.isPasswordEntered = true
      }
    }
  }
}
</script>

<style scoped>
#cancel_button {
  background-color: #00245d !important;
  color: white;
}
#verify_password {
  background-color: #53b5e6;
  color: white;
  border-radius: 0px 6px 6px 0px;
  font-size: 16px;
}
.contact-modal {
  background-color: rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(5px);
}
.close-modal {
  font-size: 16px;
  color: #00245d;
  cursor: pointer;
}
</style>
